import React from "react";

const PackedBubble = ({ className, data }) => {
	const dataDummy = data
	return (
		<div className="packed-bubble">
			{dataDummy.map((asset, index) => (
				<div
					key={index}
					className={`bubble ${className}`}
					style={{ backgroundColor: asset.color }}
				>
					<div className="bubble-wrapper">
						<div className="label">{asset.name}</div>
						<div className="children">
							{asset.dataset.map((dataItem, idx) => (
								<div key={idx} className="child">
									<div className="fill">{dataItem}</div>
								</div>
							))}
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default PackedBubble;
